import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './components/app/app.component';
import { LoginComponent } from './components';
import { AuthModule } from './auth/auth.module';
import { CoreModule } from './core/core.module';
import { MainModule } from './main.module';

@NgModule({
  declarations: [AppComponent, LoginComponent],
  imports: [BrowserModule, AppRoutingModule, CoreModule, AuthModule, MainModule],
  providers: [{ provide: 'BASE_URL', useFactory: getBaseUrl }],
  bootstrap: [AppComponent]
})
export class AppModule {}

export function getBaseUrl() {
  if (typeof environment.serverUrl === 'string') {
    return environment.serverUrl;
  } else {
    return document.getElementsByTagName('base')[0].href;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts